import React, { createContext, useCallback, useRef } from 'react';
import Header from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/header';
import { Market } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/header/types';
import { MarketProvider } from 'context/market';
import useResizeObserver from '@loomstateorg/shared-frontend/hooks/useResizeObserver';
import { Category } from 'types/category';
import { formatCustomerGroup } from '@loomstateorg/shared-frontend/helpers/formatter';
import { ALL_USERS_TAG } from 'helpers/hooks/usePermissionsChecker';

const initialMarketState = {
  market: {} as Market,
  markets: [] as Market[],
  handleMarket: {} as (market: Market) => void,
};

interface Props {
  data: any;
  categories: Category[];
  customerGroup: any;
}

export const MarketContext = createContext(initialMarketState);

const HeaderTastic = ({ data, categories, customerGroup }: Props) => {
  const headerRef = useRef<HTMLDivElement>(null);

  const setPaddingTop = useCallback(() => {
    if (headerRef.current) {
      document.body.style.paddingTop = `${headerRef.current.clientHeight - 1}px`;
    }
  }, []);

  const removePaddingTop = useCallback(() => {
    document.body.style.paddingTop = '0px';
  }, []);

  const fields = data?.data?.dataSource?.fields;

  const productSearch = !!fields?.productSearch;

  const formattedCustomerGroup = formatCustomerGroup(customerGroup?.obj?.key!);

  const filteredData = fields?.links?.filter((item: { metadata: { tags: any[] } }) =>
    item.metadata?.tags?.some((tag) => tag.sys.id === formattedCustomerGroup || tag.sys.id === ALL_USERS_TAG),
  );

  const formattedData = filteredData?.map((link: { fields: object }) => link.fields) || [];

  useResizeObserver(headerRef, setPaddingTop, removePaddingTop);

  return (
    <MarketProvider>
      <div id="header-container" ref={headerRef}>
        <Header
          navLinks={formattedData}
          categories={categories}
          customerGroup={customerGroup}
          logo={fields?.logo?.fields?.file?.url}
          src={fields?.logo?.fields?.file?.url}
          icon={fields?.icon?.[0]?.fields?.file?.url}
          logoLink={{ type: 'link', link: '/' }}
          logoMobile={data?.logoMobile}
          logoLinkMobile={{ type: 'link', link: '/' }}
          search={productSearch}
          logoScale={fields?.logoScale}
          backgroundClassName="bg-white"
          lazyPermissions
          mobileDrawerClassName="w-4/5 border border-neutral-400 bg-neutral-100"
          dashboardDefaultMessage="Dashboards"
          overlayClassName="bg-black"
          panelClassName="bg-white"
          rowSurfaceClassName="w-full rounded-md border-0 px-14 py-10 outline-none ring-0 transition-colors hover:bg-neutral-200 active:border-0 active:bg-neutral-200 focus-within:ring-0"
          navLinkTypographyClassName="text-16 2xl:text-18"
          searchDrawerClassName="bg-white"
        />
      </div>
    </MarketProvider>
  );
};

export default HeaderTastic;
